import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';
import {
    FteAccountCompletionInput,
    IEducationalInfo,
    IEmergencyContact,
    IHiringLeads,
    IStaff,
    IUserTimeOffs,
    UpdateStaffInput
} from './staff';

const STAFF_URL = `${environment.apiBaseUrl}/user`;
const TIME_API_URI = `${environment.apiBaseUrl}/time-off`;

@Injectable({
    providedIn: 'root'
})
export class StaffService {
    http: HttpClient = inject(HttpClient);

    staff(): Observable<IStaff[]> {
        return this.http.get<IStaff[]>(`${STAFF_URL}?department=None&staffType=All`);
    }

    getCasualStaffs(param: string): Observable<IStaff[]> {
        return this.http.get<IStaff[]>(`${STAFF_URL}/${param}`);
    }

    inviteCasualStaffs(input: { ids: string[] }) {
        return this.http.post(`${STAFF_URL}/invite-users`, input);
    }

    getHiringLeads(param: string): Observable<IHiringLeads[]> {
        return this.http.get<IHiringLeads[]>(`${STAFF_URL}/${param}`);
    }

    staffByFilter(filterParams: {
        department: string;
        staffType: string;
        role?: string;
    }): Observable<IStaff[]> {
        return this.http.get<IStaff[]>(STAFF_URL, { params: filterParams });
    }

    updateStaff(payload: IStaff): Observable<any> {
        return this.http.put<any>(STAFF_URL, payload);
    }
    financeUpdateStaff(payload: IStaff): Observable<IStaff> {
        return this.http.put<IStaff>(STAFF_URL + '/finance/update-profile', payload);
    }
    singleStaff(id: string): Observable<IStaff> {
        return this.http.get<IStaff>(STAFF_URL + `/single/${id}`);
    }

    userByCode(payload: string): Observable<IStaff> {
        return this.http.get<IStaff>(STAFF_URL + `/guest/${payload}`);
    }

    hiringLead(payload: { userId: string }) {
        return this.http.patch(STAFF_URL + '/hiring-manager', payload);
    }
    userDepartment(payload: { userId: string; departmentId: string }) {
        return this.http.post(STAFF_URL + '/assign-user-to-department', payload);
    }
    completeAccount(payload: UpdateStaffInput) {
        return this.http.put(STAFF_URL + '/guest/update-profile', payload);
    }

    submitReg(payload: { id: string }) {
        return this.http.patch(STAFF_URL + '/guest/submit-account-profile', payload);
    }
    updateTimeOff(input: IUserTimeOffs) {
        return this.http.patch<IStaff>(`${TIME_API_URI}/update-time-off`, input);
    }
    fteAccountCompletion(input: FteAccountCompletionInput) {
        return this.http.put(STAFF_URL + '/fte-profile-completion', input);
    }
    createFteEducations(input: IEducationalInfo) {
        return this.http.post<IEducationalInfo>(STAFF_URL + '/create/education-information', input);
    }
    createFteEmergencyContact(input: IEmergencyContact) {
        return this.http.post<IEmergencyContact>(
            STAFF_URL + '/create/emergency-information',
            input
        );
    }

    updateFteEducations(input: IEducationalInfo) {
        return this.http.post<IEducationalInfo>(STAFF_URL + '/update/education-information', input);
    }
    updateFteEmergencyContact(input: IEmergencyContact) {
        return this.http.post<IEmergencyContact>(
            STAFF_URL + '/update/emergency-information',
            input
        );
    }

    deleteFteEmergencyContactOrEmergency(id: string) {
        return this.http.delete(STAFF_URL + '/information/' + id);
    }
    getFteEmergencyContactOrEmergency(input: { userId: string; title: 'education' | 'emergency' }) {
        return this.http.get<IEducationalInfo[] | IEmergencyContact>(
            STAFF_URL + '/information/' + input.userId + '?title=' + input.title
        );
    }
}
